import { getUrlParamsFetch, sanitizeTodos, urlBackend, useLoaders, useTableFilter, useTableServerSideFiltering, useUploadFile } from "@/shared";
import { useFetchUbicacionProductoSimple } from "@/shared/actions/erp";
import { BODEGAS } from "@/shared/interfaces/erp/inventario";
import { useAuthStore } from "@/store/auth";
import { useBodegaStore } from "@/store/erp";
import { useUiConfirmModalStore, useUiStore } from "@/store/ui";
import dayjs from "dayjs";
import { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

export interface IFormSaveResporteStock {
  bodega: string[]
  producto: string | null
  ubicacion: string[]
  es_stock_crito: boolean
  es_producto_agotados: boolean
  estado: boolean,
  estado_stock: string,
  es_normal: boolean | null,
  es_critico: boolean | null,
  es_agotado: boolean | null
  //fecha_creacion: string | null
  fecha_reporte: string | null
  url_excel: string | null
  fecha_creacion_after: string | null,
  fecha_creacion_before: string | null
  serie: string | null
  descripcion_producto: string | null
}

export const TODOSREPORTESTOCK = 'TODOS';

/**
 * Convierte la seleccion multiple (array de codigos) en el valor CSV que
 * espera el backend (`?bodegas_in=A,B,C`).
 *
 * - Vacio / undefined -> null (sin filtro)
 * - Contiene el sentinel TODOS -> null (significa "todas")
 */
export const toCsvSeleccion = (
  seleccion: string[] | string | null | undefined
): string | null => {
  const arr = Array.isArray(seleccion) ? seleccion : seleccion ? [seleccion] : [];

  const crudos = arr.map((v) => String(v).trim()).filter((v) => v.length > 0);

  if (!crudos.length) return null;
  if (crudos.includes(TODOSREPORTESTOCK)) return null;

  return crudos.join(',');
};

const OPCION_TODOS_BODEGA: BODEGAS = {
  id_bodega: 'TODOS',
  estado: true,
  nombre: 'TODOS',
  codigo: 'TODOS',
  ciudad: 'TODOS',
};

export const useReporteStock = () => {

  ///* form
  const form = useForm<IFormSaveResporteStock, any, IFormSaveResporteStock>({});

  const {
    reset,
  } = form;


  const watchBodega = !(form.watch('bodega') || []).length;
  const watchUbicacion = !(form.watch('ubicacion') || []).length;

  ///* State
  const [enabled, setEnabled] = useState<boolean>(false);
  const [opcion, setOpcion] = useState('opcion1');
  const handleChangeOpcion = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOpcion(event.target.value);
    handleCleanFilterTable();
  };

  ///* Hook

  const setConfirmDialog = useUiConfirmModalStore.getState().setConfirmDialog;
  const setConfirmDialogIsOpen = useUiConfirmModalStore.getState().setConfirmDialogIsOpen;
  const user = useAuthStore.getState().user;


  const {
    bodegas,
    isLoadingbodegas
  } = useBodegaStore();

  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const isGlobalLoading = useUiStore.getState().isGlobalLoading


  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;
  const {
    columnFilters,
    setColumnFilters,
    filterObject
  } = useTableServerSideFiltering()

  ///* React Query

  const ubicacion = form.watch('ubicacion');
  const bodega = form.watch('bodega');
  const estado = form.watch('estado');
  const producto = form.watch('producto');
  const fecha_reporte = form.watch('fecha_reporte');
  const descripcion_producto = form.watch('descripcion_producto');
  const serie = form.watch('serie');

  const queryParams = useMemo(
    () => ({
      ubicaciones_in: toCsvSeleccion(ubicacion),
      bodegas_in: toCsvSeleccion(bodega),
      // Activa el scope por perfil en el backend (solo el reporte lo envia).
      scope_perfil: '1',
      estado: estado,
      fecha_creacion_after: fecha_reporte,
      fecha_creacion_before: fecha_reporte,
      producto: producto !== TODOSREPORTESTOCK ? producto : null,
      descripcion_producto: descripcion_producto !== TODOSREPORTESTOCK ? descripcion_producto : null,
      serie: serie !== TODOSREPORTESTOCK ? serie : null,
      page: pageIndex + 1,
      page_size: pageSize,
      bodega__es_cliente: false,
      ...filterObject,
    }),
    [
      ubicacion,
      bodega,
      estado,
      fecha_reporte,
      producto,
      pageIndex,
      pageSize,
      descripcion_producto,
      serie,
      filterObject
    ]
  );

  const {
    data: dataProductos,
    isLoading: isLoadingProducto,
    isRefetching,
    refetch: refetchProducto
  } = useFetchUbicacionProductoSimple({
    params: queryParams,
    enabled: enabled
  });

  function handleCleanFilterTable() {
    reset({
      estado: false,
    })

    setPagination({ pageIndex: 0, pageSize: 10 });
  }

  function handleFilterTable(params: IFormSaveResporteStock) {
    setEnabled(true);

    reset({
      ...params
    });

    setPagination({
      pageIndex: 0,
      pageSize: 10
    });

  }

  const {
    downloadExcelFileWithAxios
  } = useUploadFile();

  const handleDownloadFile = async () => {

    try {
      setIsGlobalLoading(true);
      const {
        bodega,
        ubicacion,
        producto,
        serie,
        descripcion_producto
      } = form.getValues()

      const queryParams = getUrlParamsFetch({
        serie: sanitizeTodos(serie),
        descripcion_producto: sanitizeTodos(descripcion_producto),
        bodegas_in: toCsvSeleccion(bodega) ?? undefined,
        ubicaciones_in: toCsvSeleccion(ubicacion) ?? undefined,
        producto: sanitizeTodos(producto),
        email: user?.email
      });

      const resp = await downloadExcelFileWithAxios(
        `${urlBackend}api/v1/ubicacion-producto-simple/excel/?${queryParams}`,
        `reporte_stock_actual_${dayjs().format('YYYY-MM-DD hh:mm')}`
      )

      switch (resp.code) {
        case 504:
        case 209:
          setConfirmDialog({
            isOpen: true,
            title: 'Generación de reporte.',
            subtitle:
              `El documento correspondiente al reporte de stock actual será enviado al correo registrado: ${user?.email}.`,
            onConfirm: () => {

              //handleDownloadFile();
              setConfirmDialogIsOpen(false)
            },
            onClose: () => {
              setConfirmDialogIsOpen(false)
            }
          });
          break;
        case 200:
          toast.success('Reporte de stock generado.')
          break;
        default:
          break;
      }


    } catch (error) {
      setIsGlobalLoading(false);
    } finally {
      setIsGlobalLoading(false);
    }

  }

  const bodegaAll = useMemo(() => {
    // "TODOS" SOLO para superusuario (ve TODAS). Un usuario restringido ve
    // únicamente sus bodegas asignadas -> sin "TODOS".
    const u = useAuthStore.getState().user as any;
    return u?.is_superuser ? [OPCION_TODOS_BODEGA, ...bodegas] : bodegas
  }, [isLoadingbodegas, bodegas])

  useLoaders(
    isGlobalLoading
  )

  //const watchBodega = false
  //const watchUbicacion= false

  return {
    watchBodega,
    watchUbicacion,
    setOpcion,
    handleChangeOpcion,
    opcion,
    form,
    enabled,
    setEnabled,
    handleFilterTable,
    handleCleanFilterTable,
    dataProductos,
    isLoadingProducto,
    isRefetching,
    pagination,
    setPagination,
    columnFilters,
    setColumnFilters,
    refetchProducto,
    handleDownloadFile,
    //handleEnviarReporte,
    //fetchUbicacionesWithTodos,
    bodegaAll,
    isLoadingbodegas
  }
}